import gql from 'graphql-tag';

import fileFragment from '~/shared/graphql-queries/files/file-fragment';

export default gql`
  mutation createManyFileMutation($records: [CreateManyFileInput!]!) {
    createManyFileMutation(records: $records) {
      recordIds
      records {
        ...FileFragment
      }
      message
      title
    }
  }
  ${fileFragment}
`;
